import {
    CREATE_STITCHING_DC_FAILURE_DK,
    CREATE_STITCHING_DC_REQUEST_DK,
    CREATE_STITCHING_DC_SUCCESS_DK,
    CREATE_USER_FORM_STITCHING_DC_DK,
    FETCH_SINGLE_STITCHING_DC_FAILURE_DK,
    FETCH_SINGLE_STITCHING_DC_REQUEST_DK,
    FETCH_SINGLE_STITCHING_DC_SUCCESS_DK,
    FETCH_STITCHING_DC_FAILURE_DK,
    FETCH_STITCHING_DC_REQUEST_DK,
    FETCH_STITCHING_DC_SUCCESS_DK,
    NAVIGATE_STITCHING_DC_DETAILS_DK,
    NAVIGATE_STITCHING_DC_DK,
    STITCHING_DC_USERFORM_RESET_DK,
    UPDATE_STITCHING_DC_FAILURE_DK,
    UPDATE_STITCHING_DC_REQUEST_DK,
    UPDATE_STITCHING_DC_SUCCESS_DK,
    DELETE_STITCHING_DC_REQUEST_DK,
    DELETE_STITCHING_DC_SUCCESS_DK,
    DELETE_STITCHING_DC_FAILURE_DK,
    STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_STITCHING_DC_STYLE_REQUEST_DK,
    FETCH_STITCHING_DC_STYLE_SUCCESS_DK,
    FETCH_STITCHING_DC_STYLE_FAILURE_DK,
    FETCH_STITCHING_DC_INVOICE_REQUEST_DK,
    FETCH_STITCHING_DC_INVOICE_SUCCESS_DK,
    FETCH_STITCHING_DC_INVOICE_FAILURE_DK,
    RESET_STITCHING_DC_INVOICE_DK
} from './stitchingDC.actionsType';

export const STITCHING_DC_DK = 'stitchingDcDK';

let initialState = {
    loading: false,
    stitchingDC: [],
    stitchingDCInvoice: [],
    stitchingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        fldIncludeAccessory: false
    },
    selectedStitchingDC: {},
    detailsId: '',
    activeKey: 1,
    isStitchingDC: false,
    stitchingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let stitchingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_STITCHING_DC_REQUEST_DK:
        case FETCH_STITCHING_DC_INVOICE_REQUEST_DK:
        case FETCH_STITCHING_DC_STYLE_REQUEST_DK:
        case CREATE_STITCHING_DC_REQUEST_DK:
        case FETCH_SINGLE_STITCHING_DC_REQUEST_DK:
        case UPDATE_STITCHING_DC_REQUEST_DK:
        case DELETE_STITCHING_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingDC: updatePayload
            };
        case FETCH_STITCHING_DC_INVOICE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingDCInvoice: updatePayload
            };
        case FETCH_STITCHING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingDCStyle: updatePayload?.PONO
            };
        case CREATE_STITCHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldIncludeAccessory: false
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_STITCHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedStitchingDC: updatePayload,
                userform: updatePayload
            };
        case UPDATE_STITCHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedStitchingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldIncludeAccessory: false
                },
                detailsId: ''
            };
        case DELETE_STITCHING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldIncludeAccessory: false
                },
                detailsId: '',
                selectedStitchingDC: {}
            };
        case FETCH_STITCHING_DC_FAILURE_DK:
        case FETCH_STITCHING_DC_INVOICE_FAILURE_DK:
        case FETCH_STITCHING_DC_STYLE_FAILURE_DK:
        case FETCH_SINGLE_STITCHING_DC_FAILURE_DK:
        case CREATE_STITCHING_DC_FAILURE_DK:
        case UPDATE_STITCHING_DC_FAILURE_DK:
        case DELETE_STITCHING_DC_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STITCHING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_STITCHING_DC_INVOICE_DK:
            return {
                ...state,
                stitchingDCInvoice: []
            };
        case STITCHING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldIncludeAccessory: false
                },
                selectedStitchingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_STITCHING_DC_DETAILS_DK:
            return {
                ...state,
                isStitchingDC: true,
                stitchingDCSelectedValue: updatePayload.stitchingDCSelectedValue
            };
        case NAVIGATE_STITCHING_DC_DK:
            return {
                ...state,
                isStitchingDC: false
            };
        case STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldIncludeAccessory: false
                },
                activeKey: 2
            };
        case STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldIncludeAccessory: false
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
